export default (function (value) {
  return value.length === 0;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isEmpty.js
// module id = 125
// module chunks = 1